import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import StepExperienceLevel from './steps/StepExperienceLevel';
import StepCurrentlyStudying from './steps/StepCurrentlyStudying';
import StepIndustries from './steps/StepIndustries';
import PuppeteerTemplateSelector from '../../../ResumeBuilderPuppeteer/PuppeteerTemplateSelector';
import './styles/scratchai.css';

const STEPS = {
  EXPERIENCE: 'experience',
  STUDYING: 'studying',
  INDUSTRIES: 'industries',
  TEMPLATES: 'templates',
};

const pv = {
  initial: { opacity: 0, x: 40 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -40 },
};

const pt = { duration: 0.32, ease: [0.22, 1, 0.36, 1] };

const ScratchAIFlow = ({ theme, toggleTheme, onBack: onBackToLanding }) => {
  const [step, setStep] = useState(STEPS.EXPERIENCE);
  const [experience, setExperience] = useState(null);
  const [, setStudying] = useState(null);
  const [industry, setIndustry] = useState(null);

  const handleExperience = (val) => {
    setExperience(val);
    setStep(val === 'student' ? STEPS.STUDYING : STEPS.INDUSTRIES);
  };

  const handleStudying = (val) => {
    setStudying(val);
    setStep(STEPS.TEMPLATES);
  };

  const handleIndustry = (val) => {
    setIndustry(val);
    setStep(STEPS.TEMPLATES);
  };

  const backFromStudying = () => setStep(STEPS.EXPERIENCE);
  const backFromIndustries = () => setStep(STEPS.EXPERIENCE);
  const backFromTemplates = () =>
    setStep(experience === 'student' ? STEPS.STUDYING : STEPS.INDUSTRIES);

  return (
    <>
      <AnimatePresence mode="wait">
        {step === STEPS.EXPERIENCE && (
          <motion.div
            key="exp"
            variants={pv}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={pt}
          >
            <StepExperienceLevel
              theme={theme}
              toggleTheme={toggleTheme}
              onSelect={handleExperience}
              onBack={onBackToLanding}
            />
          </motion.div>
        )}

        {step === STEPS.STUDYING && (
          <motion.div
            key="study"
            variants={pv}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={pt}
          >
            <StepCurrentlyStudying
              theme={theme}
              toggleTheme={toggleTheme}
              onSelect={handleStudying}
              onBack={backFromStudying}
            />
          </motion.div>
        )}

        {step === STEPS.INDUSTRIES && (
          <motion.div
            key="ind"
            variants={pv}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={pt}
          >
            <StepIndustries
              theme={theme}
              toggleTheme={toggleTheme}
              experience={experience}
              onSelect={handleIndustry}
              onBack={backFromIndustries}
            />
          </motion.div>
        )}

        {step === STEPS.TEMPLATES && (
          <motion.div
            key="tpl"
            variants={pv}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={pt}
          >
            <PuppeteerTemplateSelector
              theme={theme}
              toggleTheme={toggleTheme}
              onBack={backFromTemplates}
              experience={experience}
              industry={industry}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default ScratchAIFlow;
